import { render, staticRenderFns } from "./newTabV2.vue?vue&type=template&id=19f8998d&scoped=true&"
import script from "./newTabV2.vue?vue&type=script&lang=js&"
export * from "./newTabV2.vue?vue&type=script&lang=js&"
import style0 from "./newTabV2.vue?vue&type=style&index=0&id=19f8998d&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8998d",
  null
  
)

export default component.exports